import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
import Icon from './Icon';
export const LoginButton = ({ onClick, vcs, text }) => {
    return _jsxs("button", { onClick: onClick, className: clsx('btn btn--login', {
            [`btn--${vcs}`]: vcs,
        }), "data-testid": 'login-' + vcs, children: [_jsx(Icon, { name: vcs ? vcs : 'sign-in', className: 'mr-2' }), text] });
};
